import { Slot, Skeleton, Text } from '@costar-ui/components';
import { IconBuildings } from '@costar-ui/icons/csg/IconBuildings';
import { IconMobile } from '@costar-ui/icons/csg/IconMobile';
import { IconPhone } from '@costar-ui/icons/csg/IconPhone';
import { IconPhonePlus } from '@costar-ui/icons/csg/IconPhonePlus';
import React from 'react';

var Phone = function Phone(props) {
  var labels = props.labels,
    numbers = props.numbers,
    testId = props.testId,
    skeletonCount = props.skeletonCount,
    isLoading = props.isLoading;
  // listings graphql __typename is being read as a value
  var phoneNumber = {
    office: numbers === null || numbers === void 0 ? void 0 : numbers.office,
    mobile: numbers === null || numbers === void 0 ? void 0 : numbers.mobile,
    main: numbers === null || numbers === void 0 ? void 0 : numbers.main,
    other: numbers === null || numbers === void 0 ? void 0 : numbers.other
  };
  return isLoading ? /*#__PURE__*/React.createElement(Slot, {
    direction: "vertical",
    gap: "xs",
    className: "csg-tw-skeleton-phone-numbers"
  }, skeletonCount === 1 ? /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25"
  }) : skeletonCount === 2 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25"
  }))) : numbers && /*#__PURE__*/React.createElement(Slot, {
    as: "span",
    direction: "vertical",
    testId: testId
  }, phoneNumber !== null && phoneNumber !== void 0 && phoneNumber.office ? /*#__PURE__*/React.createElement(Slot, {
    as: "span",
    alignItems: "center",
    gap: "sm",
    className: "h-max items-start",
    testId: "phone-number-office-wrapper"
  }, /*#__PURE__*/React.createElement(Slot, {
    as: "span",
    title: labels === null || labels === void 0 ? void 0 : labels.office,
    className: "w-5",
    testId: "phone-number-office-icon-label"
  }, /*#__PURE__*/React.createElement(IconPhone, {
    size: "1.125rem",
    color: "text-on-base",
    transform: "scale(.96)",
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement(Text, {
    testId: "phone-number-office",
    className: "wrap-anywhere"
  }, phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.office)) : null, phoneNumber !== null && phoneNumber !== void 0 && phoneNumber.mobile ? /*#__PURE__*/React.createElement(Slot, {
    as: "span",
    gap: "sm",
    alignItems: "center",
    className: "h-max items-start",
    testId: "phone-number-mobile-wrapper"
  }, /*#__PURE__*/React.createElement(Slot, {
    as: "span",
    title: labels === null || labels === void 0 ? void 0 : labels.mobile,
    testId: "phone-number-mobile-icon-label",
    className: "w-5"
  }, /*#__PURE__*/React.createElement(IconMobile, {
    size: "1.25rem",
    color: "text-on-base",
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement(Text, {
    testId: "phone-number-mobile",
    className: "wrap-anywhere"
  }, phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.mobile)) : null, phoneNumber !== null && phoneNumber !== void 0 && phoneNumber.main ? /*#__PURE__*/React.createElement(Slot, {
    as: "span",
    gap: "sm",
    alignItems: "center",
    className: "h-max items-start",
    testId: "phone-number-main-wrapper"
  }, /*#__PURE__*/React.createElement(Slot, {
    as: "span",
    title: labels === null || labels === void 0 ? void 0 : labels.main,
    testId: "phone-number-main-icon-label",
    className: "w-5"
  }, /*#__PURE__*/React.createElement(IconBuildings, {
    size: "1.25rem",
    color: "text-on-base",
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement(Text, {
    testId: "phone-number-main",
    className: "wrap-anywhere"
  }, phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.main)) : null, phoneNumber !== null && phoneNumber !== void 0 && phoneNumber.other ? /*#__PURE__*/React.createElement(Slot, {
    as: "span",
    gap: "sm",
    className: "h-max items-start",
    alignItems: "center",
    testId: "phone-number-other-wrapper"
  }, /*#__PURE__*/React.createElement(Slot, {
    as: "span",
    title: labels === null || labels === void 0 ? void 0 : labels.other,
    testId: "phone-number-other-icon-label",
    className: "w-5"
  }, /*#__PURE__*/React.createElement(IconPhonePlus, {
    size: "1.25rem",
    color: "text-on-base",
    transform: "scale(.9)",
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement(Text, {
    testId: "phone-number-other",
    className: "wrap-anywhere"
  }, phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.other)) : null);
};

export { Phone };
//# sourceMappingURL=phone.esm.js.map
